"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const mollieCardFormSelector = '.js-mollie_card_form';
const mollieScriptUrl = 'https://js.mollie.com/v2/mollie.js';
const turnstileAnswerPollMs = 100;
function isValidDataset(data) {
    if (typeof data !== 'object' || data === null) {
        return false;
    }
    const d = data;
    return typeof d.checkoutUrl === 'string' && typeof d.locale === 'string';
}
let mollieScript = null;
function loadMollieScript() {
    if (!mollieScript) {
        mollieScript = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = mollieScriptUrl;
            script.onload = () => resolve();
            script.onerror = () => {
                mollieScript = null;
                script.remove();
                reject(new Error(`Could not load ${mollieScriptUrl}`));
            };
            document.head.append(script);
        });
    }
    return mollieScript;
}
// The Turnstile script writes its answer into the input without an event.
function waitForTurnstileAnswer(input, isDestroyed) {
    return new Promise(resolve => {
        const poll = () => {
            if (isDestroyed()) {
                return;
            }
            if (input.value !== '') {
                resolve();
            }
            else {
                window.setTimeout(poll, turnstileAnswerPollMs);
            }
        };
        poll();
    });
}
function createCheckout(element, checkoutUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const body = new URLSearchParams();
        element.querySelectorAll('input[type="hidden"]').forEach(input => {
            body.append(input.name, input.value);
        });
        const response = yield fetch(checkoutUrl, { method: 'POST', body });
        if (response.ok) {
            return { created: true, answer: yield response.json() };
        }
        if (response.status === 422) {
            const { message, reload_url: reloadUrl } = yield response.json();
            return { created: false, message, reloadUrl };
        }
        throw new Error(`Checkout request answered ${response.status}`);
    });
}
// Charger appends the checkout id to the redirect URL it gives Mollie in the same way.
function withCheckoutId(redirectUrl, checkoutId) {
    const separator = redirectUrl.includes('?') ? '&' : '?';
    return `${redirectUrl}${separator}checkout_id=${encodeURIComponent(checkoutId)}`;
}
function hideLoader(element) {
    var _a;
    (_a = element.querySelector('.js-mollie_card_form_loader')) === null || _a === void 0 ? void 0 : _a.remove();
}
function showError(element, message, reloadUrl) {
    const errorArea = element.querySelector('.js-mollie_card_form_error');
    const messageElement = element.querySelector('.js-mollie_card_form_error_message');
    const reloadLink = element.querySelector('.js-mollie_card_form_reload_link');
    hideLoader(element);
    if (message && messageElement) {
        messageElement.textContent = message;
    }
    if (reloadUrl && reloadLink) {
        reloadLink.href = reloadUrl;
    }
    if (errorArea) {
        errorArea.hidden = false;
    }
}
window.up.compiler(mollieCardFormSelector, (element, data) => __awaiter(void 0, void 0, void 0, function* () {
    const turnstileInput = element.querySelector('.js-mollie_card_form_turnstile_response');
    const mountPoint = element.querySelector('.js-mollie_card_form_mount');
    if (!isValidDataset(data) || !turnstileInput || !mountPoint) {
        // eslint-disable-next-line no-console
        console.error('Mollie card form: invalid or missing data attributes or elements', data);
        return;
    }
    let destroyed = false;
    let cardComponent;
    window.up.destructor(element, () => {
        destroyed = true;
        cardComponent === null || cardComponent === void 0 ? void 0 : cardComponent.unmount();
    });
    try {
        yield waitForTurnstileAnswer(turnstileInput, () => destroyed);
        const result = yield createCheckout(element, data.checkoutUrl);
        if (destroyed) {
            return;
        }
        if (!result.created) {
            showError(element, result.message, result.reloadUrl);
            return;
        }
        // Browser tests never load Mollie, so they follow the redirect Mollie sends after payment.
        if (document.body.classList.contains('test')) {
            if (result.answer.redirect_url) {
                window.location.assign(withCheckoutId(result.answer.redirect_url, result.answer.checkout_id));
            }
            return;
        }
        yield loadMollieScript();
        if (destroyed) {
            return;
        }
        if (!window.Mollie) {
            throw new Error(`${mollieScriptUrl} loaded without defining window.Mollie`);
        }
        cardComponent = window.Mollie.Checkout(result.answer.client_access_token, { locale: data.locale }).create('card-component');
        yield cardComponent.mount(mountPoint);
        hideLoader(element);
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Mollie card form: failed to set up the card component', error);
        showError(element);
    }
}));
